import { NewspaperIcon } from '@heroicons/react/outline';
import Balancer from 'react-wrap-balancer';
import HeroImage from '../../assets/blog-post-hero.jpg';
import { BlogPost, getFormattedDate } from '../../lib/blog';
import { BlogPostAuthor } from './BlogPostAuthor';

type Props = {
  post: BlogPost;
};

export const BlogPostHero = ({ post }: Props) => {
  const { title, date } = post;

  return (
    <div
      className="blog-post-hero relative"
      style={{
        backgroundImage: `url(${HeroImage.src})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <div className="content-wrapper container grid">
        <div className="blog-icon col">
          <div className="icon">
            <NewspaperIcon />
          </div>
        </div>
        <div className="content col">
          <h2 className="h3 text-brand-secondary md:h2 numeric-font-fix mb-3">
            <Balancer>{title}</Balancer>
          </h2>
          <p className="p-body">{getFormattedDate(date)}</p>
          <div className="flex flex-col justify-between space-y-3 lg:flex-row lg:items-center">
            <BlogPostAuthor post={post} />
          </div>
        </div>
      </div>
    </div>
  );
};
